<script setup>
    // Component
    import MainHeader from '@/components/HeaderComponent.vue';

    // Store
    import { useAgreementDetailStore } from '@/stores/modal/agreementDetailStore';
    import { useSetupAgreeStore } from '@/stores/setup/setupAgreeStore';
    import { useButtonDisabledStore } from '@/stores/common/disabledStore';

    // Vue
    import { getCurrentInstance, inject, onMounted, ref } from 'vue';
    import { useRouter } from 'vue-router';

    // Utis
    import utils from '@/commonProject/helpers/utils';

    // ----------------------------
    // 定数
    // ----------------------------
    const app = getCurrentInstance();

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    const router = useRouter();

    const setupAgreeStore = useSetupAgreeStore();

    const agreementDetailStore = useAgreementDetailStore();

    const agreeDisabledFlag = ref(true);

    const regulationDt = ref('');

    const regulationContent = ref('');

    // ボタン連打ガード制御
    const disabledStore = useButtonDisabledStore();

    onMounted(async () => {
        // 規約詳細用のStoreを初期化する。
        agreementDetailStore.reset();

        // 規定詳細取得APIのクエリパラメーターを生成する。
        const queryParam = {
            RegulationPk: setupAgreeStore.regulationPk,
        };

        // 規定詳細取得APIをコールする。
        const response = await agreementDetailStore.getAgreementDetailAction(app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S, queryParam);
        if (response.success) {
            regulationDt.value = utils.removeTimeDataFromDate(agreementDetailStore.RegulationDt);
            regulationContent.value = agreementDetailStore.RegulationContent;
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    });

    async function submit() {
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();
        
        const requestBody = {
            RegulationPk: setupAgreeStore.regulationPk,
            RegulationHistPk: agreementDetailStore.RegulationHistPk,
        };

        // ユーザー利用規定同意登録APIをコールして、本ユーザーの同意情報を登録する。
        const response = await setupAgreeStore.setupUserAgreementUpdateAction(app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S, requestBody);

        if (response.success) {
            // 各Storeを初期化する。
            setupAgreeStore.reset();
            agreementDetailStore.reset();

            // ホーム画面へ遷移する。
            router.push({ name: 'home' });
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }

    function agreeChange() {
        if (agreeDisabledFlag.value) {
            agreeDisabledFlag.value = false;
        } else {
            agreeDisabledFlag.value = true;
        }
    }
</script>

<style></style>

<template>
    <section id="main">
        <MainHeader />
        <div id="contents">
            <div class="whiteBox">
                <h3 class="textCenter">
                    <span>{{ $t('setupAgree.parts.pageTitle1') }}</span>
                </h3>
                <section class="whiteBoxContents" style="width: 700px">
                    <p class="pageInfo">
                        {{ $t('setupAgree.parts.pageInformation1') }}<br />
                        {{ $t('setupAgree.parts.pageInformation2') }}<br />
                        {{ $t('setupAgree.parts.pageInformation3') }}
                    </p>
                    <div class="regulationBox" style="height: calc(100% - 196px)">
                        <span class="regulationDate">{{ regulationDt }}</span>
                        <span class="regulationTitle">{{ $t('setupAgree.parts.dl1') }}</span>
                        <div class="regulationBody">{{ regulationContent }}</div>
                        <!-- <textarea v-model="regulationContent" class="baseTextArea" disabled /> -->
                    </div>
                    <ul class="btnArea center">
                        <li>
                            <input type="checkbox" id="checkbox1" class="checkbox" @change="agreeChange" />
                            <label for="checkbox1" class="checkbox label">{{ $t('setupAgree.parts.checkboxLabel1') }}</label>
                        </li>
                    </ul>
                </section>
                <section class="whiteBoxFooter">
                    <ul class="btnArea center">
                        <li>
                            <button type="button" class="btnPrimary" @click="submit" :disabled="agreeDisabledFlag || disabledStore.isDisabled">{{ $t('common.parts.entry') }}</button>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    </section>
</template>
